import { render, staticRenderFns } from "./FcStoringAgent.vue?vue&type=template&id=5a2f750b"
import script from "./FcStoringAgent.vue?vue&type=script&lang=js"
export * from "./FcStoringAgent.vue?vue&type=script&lang=js"
import style0 from "./FcStoringAgent.vue?vue&type=style&index=0&id=5a2f750b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports